import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import IndeterminateCheckbox from './indeterminate-checkbox';

const FormRaccourci = forwardRef((props, ref) => {
  const [localItem, setLocalItem] = useState(null);
  const [isManually, setIsManually] = useState(false);
  const [autoShortcut, setAutoShortcut] = useState('');

  const inputRef = useRef(null);

  useEffect(() => {
    setLocalItem(props.item);
    setAutoShortcut('');
  }, [props.item]);

  useImperativeHandle(ref, () => ({
    onKeyDown(event) {
      onInputKeyDown(event);
    },
  }));

  const update = (column, value) => {
    const updatedItem = { ...localItem, [column]: value };
    setLocalItem(updatedItem);
  };

  const submit = () => {
    props.onSubmit(localItem);
  };

  const onInputKeyDown = (event) => {
    if (!isManually) {
      OnShortcutKeyDown(event);
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const input = inputRef.current;
    if (!input) return;

    const text = input.value;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    if (event.key === 'ArrowLeft') {
      if (start === 0) return;

      setCursorPosition(start - 1);
      return;
    }

    if (event.key === 'ArrowRight') {
      if (start === text.length) return;

      setCursorPosition(start + 1);
      return;
    }

    if (event.key === 'Backspace') {
      const value = text.substring(0, start - 1) + text.substring(end);
      updateText(value, start - 1);

      return;
    }

    if (event.key === 'Delete') {
      const value = text.substring(0, start) + text.substring(end + 1);
      updateText(value, start);

      return;
    }

    if (event.key === 'Home') {
      setCursorPosition(0);
      return;
    }

    if (event.key === 'End') {
      setCursorPosition(text.length);
      return;
    }

    var char = event.key;
    if (char.length > 1) {
      return;
    }

    const value = text.substring(0, start) + char + text.substring(end);
    updateText(value, start + 1);

    //return;
  };

  const OnShortcutKeyDown = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const itemToUpdate = { ...localItem };

    itemToUpdate.ctrl = event.ctrlKey;
    itemToUpdate.alt = event.altKey;
    itemToUpdate.shift = event.shiftKey;
    itemToUpdate.code = '';

    if (
      event.key !== 'Control' &&
      event.key !== 'Shift' &&
      event.key !== 'Alt'
    ) {
      itemToUpdate.code = event.key;
    }

    if (itemToUpdate.code === ' ') {
      itemToUpdate.code = props.lang === 'fr' ? 'Espace' : 'Space';
    }

    const shortcut = [
      itemToUpdate.ctrl ? 'CTRL' : '',
      itemToUpdate.shift ? 'SHIFT' : '',
      itemToUpdate.alt ? 'ALT' : '',
      itemToUpdate.code || '',
    ]
      .filter(Boolean)
      .join(' + ');

    setLocalItem(itemToUpdate);
    setAutoShortcut(shortcut);
  };

  const updateText = (value, start) => {
    update('code', value);

    // Ensure input stays focused after update
    setCursorPosition(start);
  };

  const setCursorPosition = (position) => {
    setTimeout(() => {
      const input = inputRef.current;

      input.setSelectionRange(position, position);
      input.scrollLeft = input.scrollWidth;
      input.focus();
    }, 0);
  };

  if (!localItem) {
    return <></>;
  }

  const Manual = () => {
    if (!isManually) return <></>;

    return (
      <form>
        <div className="controls">
          <div className="control">
            <IndeterminateCheckbox
              id="chkCtrl"
              checked={localItem.ctrl}
              onChange={(event) => update('ctrl', event.target.checked)}
            />
            <label htmlFor="chkCtrl">CTRL</label>
          </div>

          <div className="control">
            <IndeterminateCheckbox
              id="chkShift"
              checked={localItem.shift}
              onChange={(event) => update('shift', event.target.checked)}
            />
            <label htmlFor="chkShift">SHIFT</label>
          </div>

          <div className="control">
            <IndeterminateCheckbox
              id="chkAlt"
              checked={localItem.alt}
              onChange={(event) => update('alt', event.target.checked)}
            />
            <label htmlFor="chkAlt">ALT</label>
          </div>

          <div className="control">
            <label htmlFor="txtKey">
              {props.lang === 'fr' ? 'Touche' : 'Key'}
            </label>
            <input
              id="txtKey"
              type="text"
              defaultValue={localItem.code}
              ref={inputRef}
              onKeyDown={onInputKeyDown}
            />
          </div>
        </div>
        <div className="actions">
          <button type="button" onClick={submit}>
            {props.lang === 'fr' ? 'Valider' : 'Submit'}
          </button>
          <button type="button" onClick={props.onClose}>
            {props.lang === 'fr' ? 'Fermer' : 'Close'}
          </button>
        </div>
      </form>
    );
  };

  const Auto = () => {
    if (isManually) {
      return <></>;
    }

    return (
      <form>
        <div className="auto">
          <p>
            {props.lang === 'fr' ? 'Ancien raccourci' : 'Old shortcut'} :{' '}
            {props.item?.shortcut}
          </p>
          <div className="control">
            <label htmlFor="txtShortcut">
              {props.lang === 'fr' ? 'Nouveau raccourci' : 'New shortcut'}
            </label>
            <input
              id="txtShortcut"
              type="text"
              value={autoShortcut}
              onKeyDown={OnShortcutKeyDown}
              disabled={true}
              onChange={(event) => setAutoShortcut(event.target.value)}
            ></input>
          </div>
        </div>
        <div className="actions">
          <button type="button" onClick={() => setAutoShortcut('')}>
            {props.lang === 'fr' ? 'Effacer' : 'Clear'}
          </button>
          <button type="button" onClick={submit}>
            {props.lang === 'fr' ? 'Valider' : 'Submit'}
          </button>
          <button type="button" onClick={props.onClose}>
            {props.lang === 'fr' ? 'Fermer' : 'Close'}
          </button>
        </div>
      </form>
    );
  };

  return (
    <fieldset>
      <legend>
        <span>
          {props.lang === 'fr'
            ? `Modifier le raccourci "${localItem.labelShortcut}"`
            : `Update shortcut "${localItem.labelShortcut}"`}
        </span>
        <div className="control">
          <IndeterminateCheckbox
            id="chkManually"
            checked={isManually}
            onChange={(event) => setIsManually(event.target.checked)}
          />
          <label htmlFor="chkManually">
            {props.lang === 'fr'
              ? 'Saisir manuellement le raccourci'
              : 'Enter shortcut manually'}
          </label>
        </div>
      </legend>
      <Manual></Manual>
      <Auto></Auto>
    </fieldset>
  );
});

export default FormRaccourci;
